import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withModifiers as _withModifiers, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "step__title" }
const _hoisted_4 = {
  key: 0,
  class: "step-profile_refine"
}
const _hoisted_5 = { class: "" }
const _hoisted_6 = {
  value: null,
  disabled: "",
  hidden: "",
  selected: ""
}
const _hoisted_7 = ["value"]
const _hoisted_8 = {
  value: null,
  disabled: "",
  hidden: "",
  selected: ""
}
const _hoisted_9 = ["value"]
const _hoisted_10 = { class: "step__title" }
const _hoisted_11 = { class: "step__title" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = {
  key: 1,
  class: "daily-rate-information",
  role: "information"
}
const _hoisted_15 = { class: "bold" }

import {getPageLocale} from '@malt/dom';
    import StrategyBriefHubStepLayout from '@/brief-hub/common/ui/layout/StrategyBriefHubStepLayout.vue';
    import BriefAdvancedFeatureInformationDialog from '@/brief-hub/common/ui/components/BriefAdvancedFeatureInformationDialog.client.vue';
    import StrategyCategoriesSuggestion from '@/brief-hub/common/ui/components/StrategyCategoriesSuggestion.vue';
    import {computed, ComputedRef, inject, Ref, ref, watch} from 'vue';
    import {CategoryPredictionResource, ExperienceLevel, StrategyFreelancerBriefRequest} from '@/common/api/api-raw-types';
    import {useGlobalProperties} from '@malt/vue3-use';
    import {useRoute} from 'vue-router';
    import {useBriefStrategyStore} from '@/brief-hub/stores/briefStrategy.store';
    import {CategoryResult} from '@/brief-hub/deposit/freelancer/CategoryResult';
    import {FamilyResult} from '@/brief-hub/deposit/freelancer/FamilyResult';
    import {FreelancerProfileService} from '@/brief-hub/deposit/freelancer/FreelancerProfileService';
    import {DI} from '@/brief-hub/config/DependencyInjection';
    import {StrategyBriefService} from '@/brief-hub/brief/StrategyBriefService';
    import {getCurrencySymbolFrom} from '@malt/i18n/src/currency/Formatter';
    import {useMediaQuery} from '@malt/joy-entrypoint/src/vue/use';
    import {useBriefAmplitudeEvent} from '@/common/composable/useBriefAmplitudeEvent';
    import {pushVJoySnackbar} from '@maltjoy/core-vue';

    interface ExperienceLevelWithLabel {
        label: string;
        years: string;
        value: ExperienceLevel;
    }

    const STRATEGY_JOBTITLE_MIN_LENGTH_FOR_PREDICTION = 3;
    const STRATEGY_JOBTITLE_MIN_LENGTH = 6;
    const STRATEGY_JOBTITLE_MAX_LENGTH = 100;
    const STRATEGY_MIN_DAILY_FREELANCE_RATE = 1000;
    const MIN_DAILY_FREELANCE_RATE = 125;
    const MAX_DAILY_FREELANCE_RATE = 20000;
    
export default /*@__PURE__*/_defineComponent({
  __name: 'StrategyBriefFreelancerProfile',
  setup(__props) {

    const briefStrategyStore = useBriefStrategyStore();

    const {$msg, $features} = useGlobalProperties();
    const route = useRoute();
    const {matchMedia} = useMediaQuery();
    const {triggerBriefFunnelStepEnteredAmplitudeEvent} = useBriefAmplitudeEvent();

    const refine = ref(true);
    const dailyFreelancerMinLimitWithCurrency = ref<string | null>(null);
    const currencySymbol = computed(() => (currency.value ? getCurrencySymbolFrom(currency.value) : ''));
    const isMobile = computed(() => matchMedia.value.max.Xs);

    const freelancerProfileService = inject<FreelancerProfileService>(DI.freelancerProfileService);
    const strategyBriefService = inject<StrategyBriefService>(DI.strategyBriefService);
    const jobTitle: Ref<string> = ref(briefStrategyStore.briefStrategyFreelancerProfile.selectedJobTitle);
    const freelancerCategory: Ref<string | null> = ref(briefStrategyStore.briefStrategyFreelancerProfile.selectedCategory);
    const freelancerFamily: Ref<string | null> = ref(briefStrategyStore.briefStrategyFreelancerProfile.selectedFamily);
    const dailyFreelancerRate: Ref<number> = ref(
        briefStrategyStore.briefStrategyFreelancerProfile.selectedDailyFreelancerRate || STRATEGY_MIN_DAILY_FREELANCE_RATE,
    );
    const experienceLevel: Ref<ExperienceLevel | null> = ref(briefStrategyStore.briefStrategyFreelancerProfile.selectedExperienceLevel);
    const suggestedCategories: Ref<CategoryPredictionResource[]> = ref([]);
    const families = ref<FamilyResult[]>();
    const currency = ref<string | undefined>(undefined);
    const isCategorySuggestionChecked = computed(() =>
        suggestedCategories.value.find((suggestion) => suggestion.category.categoryId === freelancerCategory.value),
    );
    const showRefineButton = computed(() => {
        if (jobTitleHasAbsoluteSinglePrediction()) {
            return false;
        }
        return suggestedCategories.value.length > 0;
    });
    const jobTitleInputRef = ref();

    /**
     * We can request predictions when:
     * - job title has 3 characters or more
     */
    const isJobTitleReadyForPrediction: ComputedRef = computed<boolean>(() => {
        return jobTitle.value?.trim()?.length >= STRATEGY_JOBTITLE_MIN_LENGTH_FOR_PREDICTION;
    });

    /**
     * We must display an error message when:
     * - job title is less than 6 characters,
     * Except :
     * - if a prediction has a probability score of 1
     */
    const jobTitleError = computed<boolean>(() => {
        const tooShort = (jobTitle.value?.length && jobTitle.value?.trim()?.length < STRATEGY_JOBTITLE_MIN_LENGTH) || false;
        const absoluteSinglePrediction = jobTitleHasAbsoluteSinglePrediction();
        return tooShort && !absoluteSinglePrediction;
    });

    function jobTitleHasAbsoluteSinglePrediction(): boolean {
        return suggestedCategories.value.length === 1 && suggestedCategories.value[0].probability >= 1;
    }

    const hasFreelancerDailyRateWarning = computed<boolean>(() => {
        if (!dailyFreelancerRate.value) {
            return false;
        }
        return dailyFreelancerRate.value < STRATEGY_MIN_DAILY_FREELANCE_RATE - 100;
    });

    const dailyFreelancerRateErrorMin = computed<boolean>(() => {
        return (dailyFreelancerRate.value && dailyFreelancerRate.value < MIN_DAILY_FREELANCE_RATE) || false;
    });

    const dailyFreelancerRateErrorMax = computed<boolean>(() => {
        return (dailyFreelancerRate.value && dailyFreelancerRate.value > MAX_DAILY_FREELANCE_RATE) || false;
    });

    const potentialCategories = computed<CategoryResult[]>(() => {
        return families.value?.find((family) => family.family === freelancerFamily.value)?.categories || [];
    });

    const isCompleteStep: ComputedRef<boolean> = computed<boolean>(() => {
        return !!(
            freelancerCategory.value &&
            experienceLevel.value &&
            dailyFreelancerRate.value &&
            dailyFreelancerRate.value >= MIN_DAILY_FREELANCE_RATE &&
            dailyFreelancerRate.value <= MAX_DAILY_FREELANCE_RATE &&
            !jobTitleError.value
        );
    });

    async function init() {
        const [data, error] = await strategyBriefService!.getBriefCurrency();
        if (!data || error) {
            pushVJoySnackbar({
                props: {
                    message: $msg('customer.brief.error.unknown'),
                    level: 'error',
                },
            });
        } else {
            currency.value = data.currencyCode;
            dailyFreelancerMinLimitWithCurrency.value = new Intl.NumberFormat(getPageLocale(), {
                style: 'currency',
                currency: currency.value,
                minimumFractionDigits: 0,
            }).format(STRATEGY_MIN_DAILY_FREELANCE_RATE);
        }
        families.value = await getFamilySelection();

        // @ts-ignore
        // jobTitleInputRef.value?.focus(); // Todo: Uncomment that and Fix it

        if (document.referrer) {
            briefStrategyStore.updateOriginReferrer!(document.referrer);
        }

        triggerBriefFunnelStepEnteredAmplitudeEvent('freelancer_profile', 1);
    }

    init();

    async function getFamilySelection(): Promise<FamilyResult[] | []> {
        const [data, error] = await freelancerProfileService!.retrieveFamiliesAndCategories();
        if (error || !data) {
            pushVJoySnackbar({
                props: {
                    message: $msg('customer.brief.error.unknown'),
                    level: 'error',
                },
            });
            return [];
        }
        return data.filter(({family}) => family !== 'other');
    }

    function findFamilyIdFromSelectedCategoryId(categoryId: string): string | null {
        return families.value?.find((family) => family.categories.find((category) => categoryId === category.category))?.family || null;
    }

    const levels = computed<ExperienceLevelWithLabel[]>(() => {
        const tagFor = (levelValue: ExperienceLevel) => $msg(`customer.brief.exec.form.freelancer.profile.level.tag.${levelValue}`);
        const yearsFor = (levelValue: ExperienceLevel) => $msg(`customer.brief.exec.form.freelancer.profile.level.years.${levelValue}`);
        return [ExperienceLevel.ENTRY, ExperienceLevel.INTERMEDIATE, ExperienceLevel.EXPERT, ExperienceLevel.EXPERT_PLUS].map((experienceLevel) => ({
            label: tagFor(experienceLevel),
            years: yearsFor(experienceLevel),
            value: experienceLevel,
        }));
    });

    function handleFindCategorySuggestion(predictions: CategoryPredictionResource[]): void {
        if (predictions.length) {
            suggestedCategories.value = predictions;
            freelancerFamily.value = predictions[0].category.familyId;
            freelancerCategory.value = predictions[0].category.categoryId;
        } else {
            suggestedCategories.value = [];
        }
    }

    function handleSelectCategorySuggestion(event: CustomEvent): void {
        if (event.detail.checked) {
            const categoryId = event.detail.value;
            freelancerFamily.value = findFamilyIdFromSelectedCategoryId(categoryId);
            freelancerCategory.value = categoryId;
            refine.value = false;
        } else {
            freelancerFamily.value = null;
            freelancerCategory.value = null;
        }
    }

    function handleUpdateSelectFamily(family: string) {
        freelancerFamily.value = family;
        freelancerCategory.value = null;
    }

    function handleExperienceLevelChange(event: CustomEvent) {
        experienceLevel.value = event.detail.checked ? (event.detail.value as ExperienceLevel) : null;
    }

    function onJobTitleChange(event) {
        jobTitle.value = event.target?.value;
        if (jobTitle.value?.trim()?.length < STRATEGY_JOBTITLE_MIN_LENGTH_FOR_PREDICTION) {
            suggestedCategories.value = [];
        }
    }

    function onFormChange() {
        if (isCompleteStep.value) {
            const payload: StrategyFreelancerBriefRequest = {
                dailyFreelancerRate: dailyFreelancerRate.value,
                experienceLevel: experienceLevel.value!,
                freelancerCategory: freelancerCategory.value!,
                fromSignup: route.query.origin === 'signup',
                jobTitle: jobTitle.value,
                searchId: route.query.searchId?.toString(),
            };
            briefStrategyStore.updatePayload({type: 'StrategyFreelancerBriefRequest', payload: payload});
        } else {
            briefStrategyStore.resetPayload();
        }
    }

    function handleRefine() {
        if (isJobTitleReadyForPrediction.value) {
            if (!suggestedCategories.value.length) {
                refine.value = true;
            } else if (isCategorySuggestionChecked.value) {
                refine.value = false;
            } else if (freelancerCategory.value) {
                refine.value = true;
            }
        } else {
            refine.value = true;
        }
    }

    watch([jobTitle, freelancerCategory, dailyFreelancerRate, experienceLevel, suggestedCategories], onFormChange, {immediate: true});
    watch(suggestedCategories, handleRefine, {immediate: true});

return (_ctx: any,_cache: any) => {
  const _component_VJoyInput = _resolveComponent("VJoyInput")!
  const _component_VJoyFormError = _resolveComponent("VJoyFormError")!
  const _component_VJoyIcon = _resolveComponent("VJoyIcon")!
  const _component_VJoyLabel = _resolveComponent("VJoyLabel")!
  const _component_VJoySelect = _resolveComponent("VJoySelect")!
  const _component_VJoyWrapper = _resolveComponent("VJoyWrapper")!
  const _component_joy_selectable_item = _resolveComponent("joy-selectable-item")!
  const _component_joy_selectable_item_group = _resolveComponent("joy-selectable-item-group")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(StrategyBriefHubStepLayout, null, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref($msg)('customer.brief.exec.form.freelancer.profile.title')), 1)
      ]),
      default: _withCtx(() => [
        _createVNode(_component_VJoyWrapper, {
          direction: "column",
          align: "stretch",
          "no-margin": ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_VJoyInput, {
              ref_key: "jobTitleInputRef",
              ref: jobTitleInputRef,
              modelValue: jobTitle.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((jobTitle).value = $event)),
              name: "job-title",
              placeholder: _unref($msg)('customer.brief.exec.form.freelancer.profile.jobtitle.placeholder'),
              min: STRATEGY_JOBTITLE_MIN_LENGTH,
              max: STRATEGY_JOBTITLE_MAX_LENGTH,
              "data-testid": "brief-strategy-job-title-input",
              label: _unref($msg)('customer.brief.exec.form.freelancer.profile.jobtitle.label'),
              onInput: onJobTitleChange
            }, null, 8, ["modelValue", "placeholder", "label"]),
            _createVNode(_Transition, { name: "slide-fade" }, {
              default: _withCtx(() => [
                (jobTitleError.value)
                  ? (_openBlock(), _createBlock(_component_VJoyFormError, {
                      key: 0,
                      "no-html-error-text": "This is an error"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("ul", null, [
                          _createElementVNode("li", null, [
                            _createTextVNode(_toDisplayString(_unref($msg)('customer.brief.exec.form.freelancer.profile.job.title.length.error')) + " ", 1),
                            _createElementVNode("span", _hoisted_1, _toDisplayString(_unref($msg)('customer.brief.exec.form.freelancer.profile.job.title.length.error.more')), 1)
                          ])
                        ])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_Transition, { name: "slide-fade" }, {
              default: _withCtx(() => [
                (isJobTitleReadyForPrediction.value)
                  ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
                      _createVNode(_component_VJoyWrapper, {
                        direction: "column",
                        align: "stretch",
                        "no-margin": ""
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", null, [
                            _createElementVNode("h2", _hoisted_3, _toDisplayString(_unref($msg)('customer.brief.exec.form.freelancer.profile.categories.suggestion.title')), 1),
                            _createVNode(StrategyCategoriesSuggestion, {
                              "visible-result": 3,
                              value: jobTitle.value,
                              "selected-category": freelancerCategory.value,
                              categories: suggestedCategories.value.map((c) => c.category),
                              onLoad: handleFindCategorySuggestion,
                              onSelect: handleSelectCategorySuggestion
                            }, null, 8, ["value", "selected-category", "categories"]),
                            _createVNode(_Transition, { name: "slide-fade" }, {
                              default: _withCtx(() => [
                                (showRefineButton.value)
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 0,
                                      class: "refine-link",
                                      "data-testid": "refine-link",
                                      onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (refine.value = !refine.value), ["prevent"]))
                                    }, [
                                      _createTextVNode(_toDisplayString(_unref($msg)('customer.brief.exec.form.freelancer.profile.categories.suggestion.refine')) + " ", 1),
                                      _createVNode(_component_VJoyIcon, {
                                        name: refine.value ? 'chevron-top' : 'chevron-down'
                                      }, null, 8, ["name"])
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }),
                            _createVNode(_Transition, { name: "slide-fade" }, {
                              default: _withCtx(() => [
                                (refine.value)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                      _createVNode(_component_VJoyWrapper, {
                                        direction: "column",
                                        align: "stretch"
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("div", _hoisted_5, [
                                            _createVNode(_component_VJoyLabel, { "html-for": "selectFamily" }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_unref($msg)('customer.brief.exec.form.freelancer.profile.family')), 1)
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_VJoySelect, {
                                              id: "selectFamily",
                                              ref: "selectCategories",
                                              modelValue: freelancerFamily.value,
                                              "onUpdate:modelValue": [
                                                _cache[2] || (_cache[2] = ($event: any) => ((freelancerFamily).value = $event)),
                                                handleUpdateSelectFamily
                                              ],
                                              "data-testid": "brief-strategy-job-family-select",
                                              "aria-label": _unref($msg)('customer.brief.exec.form.freelancer.profile.family')
                                            }, {
                                              default: _withCtx(() => [
                                                _createElementVNode("option", _hoisted_6, _toDisplayString(_unref($msg)('customer.brief.exec.form.freelancer.profile.select.family.placeholder')), 1),
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(families.value, (family, index) => {
                                                  return (_openBlock(), _createElementBlock("option", {
                                                    key: index,
                                                    value: family.family
                                                  }, _toDisplayString(family.name), 9, _hoisted_7))
                                                }), 128))
                                              ]),
                                              _: 1
                                            }, 8, ["modelValue", "aria-label"])
                                          ]),
                                          _createElementVNode("div", null, [
                                            _createVNode(_component_VJoyLabel, { "html-for": "selectCategory" }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_unref($msg)('customer.brief.exec.form.freelancer.profile.search')), 1)
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_VJoySelect, {
                                              id: "selectCategory",
                                              modelValue: freelancerCategory.value,
                                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((freelancerCategory).value = $event)),
                                              "data-testid": "brief-strategy-job-category-select",
                                              "aria-label": _unref($msg)('customer.brief.exec.form.freelancer.profile.search')
                                            }, {
                                              default: _withCtx(() => [
                                                _createElementVNode("option", _hoisted_8, _toDisplayString(_unref($msg)('customer.brief.exec.form.freelancer.profile.select.category.placeholder')), 1),
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(potentialCategories.value, (category, index) => {
                                                  return (_openBlock(), _createElementBlock("option", {
                                                    key: category.category || index,
                                                    value: category.category
                                                  }, _toDisplayString(category.name), 9, _hoisted_9))
                                                }), 128))
                                              ]),
                                              _: 1
                                            }, 8, ["modelValue", "aria-label"])
                                          ])
                                        ]),
                                        _: 1
                                      })
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", null, [
                            _createElementVNode("h2", _hoisted_10, _toDisplayString(_unref($msg)('customer.brief.exec.form.freelancer.profile.experience.level.title')), 1),
                            _createVNode(_component_joy_selectable_item_group, {
                              "full-width": !isMobile.value,
                              "data-testid": "brief-strategy-experience-level",
                              onJoySelectableItemGroupChange: handleExperienceLevelChange
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(levels.value, (level) => {
                                  return (_openBlock(), _createBlock(_component_joy_selectable_item, {
                                    id: level.value,
                                    key: level.value,
                                    value: level.value,
                                    name: "experience-level",
                                    checked: experienceLevel.value === level.value
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("strong", null, _toDisplayString(level.years), 1),
                                      _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1)),
                                      _createTextVNode(" " + _toDisplayString(level.label), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["id", "value", "checked"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["full-width"])
                          ]),
                          _createElementVNode("div", null, [
                            _createElementVNode("h2", _hoisted_11, _toDisplayString(_unref($msg)('customer.brief.exec.form.freelancer.profile.daily.rate.title')), 1),
                            _createElementVNode("p", null, _toDisplayString(_unref($msg)('customer.brief.exec.form.freelancer.profile.daily.rate.subtitle', dailyFreelancerMinLimitWithCurrency.value)), 1),
                            _createVNode(_component_VJoyWrapper, {
                              direction: "column",
                              align: "stretch",
                              "no-margin": ""
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_VJoyInput, {
                                  modelValue: dailyFreelancerRate.value,
                                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((dailyFreelancerRate).value = $event)),
                                  name: "daily-rate",
                                  type: "number",
                                  class: "brief-strategy-daily-rate-input",
                                  "data-testid": "brief-strategy-daily-rate-input",
                                  unit: _unref($msg)('customer.brief.exec.form.freelancer.profile.daily.rate.unit', currencySymbol.value),
                                  placeholder: STRATEGY_MIN_DAILY_FREELANCE_RATE,
                                  min: MIN_DAILY_FREELANCE_RATE,
                                  max: MAX_DAILY_FREELANCE_RATE
                                }, null, 8, ["modelValue", "unit"]),
                                _createElementVNode("div", null, [
                                  (dailyFreelancerRateErrorMin.value || dailyFreelancerRateErrorMax.value)
                                    ? (_openBlock(), _createBlock(_component_VJoyFormError, {
                                        key: 0,
                                        "no-html-error-text": "This is an error"
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("ul", null, [
                                            (dailyFreelancerRateErrorMin.value)
                                              ? (_openBlock(), _createElementBlock("li", _hoisted_12, _toDisplayString(_unref($msg)(
                                                            'customer.brief.exec.form.freelancer.profile.daily.rate.error.min',
                                                            MIN_DAILY_FREELANCE_RATE,
                                                        )), 1))
                                              : _createCommentVNode("", true),
                                            (dailyFreelancerRateErrorMax.value)
                                              ? (_openBlock(), _createElementBlock("li", _hoisted_13, _toDisplayString(_unref($msg)(
                                                            'customer.brief.exec.form.freelancer.profile.daily.rate.error.max',
                                                            MAX_DAILY_FREELANCE_RATE,
                                                        )), 1))
                                              : _createCommentVNode("", true)
                                          ])
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true),
                                  (hasFreelancerDailyRateWarning.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                        _createVNode(_component_VJoyIcon, { name: "info-circle" }),
                                        _createElementVNode("p", null, [
                                          _createTextVNode(_toDisplayString(_unref($msg)('customer.brief.exec.form.freelancer.profile.daily.rate.warning')) + " : ", 1),
                                          _createElementVNode("span", _hoisted_15, _toDisplayString(dailyFreelancerMinLimitWithCurrency.value), 1)
                                        ])
                                      ]))
                                    : _createCommentVNode("", true)
                                ])
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _: 1
                      })
                    ], 512)), [
                      [_vShow, !jobTitleError.value]
                    ])
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            (!_unref($features).projectProposalBriefNoMoreServiceLevelNeeded)
              ? (_openBlock(), _createBlock(BriefAdvancedFeatureInformationDialog, {
                  key: 0,
                  type: "strategy"
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})